import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { formatDate, formatNumber } from '../../lib/helpers/formatters';

function ContextSummary({ deal, activities }) {
  const [t] = useTranslation('AI_EMAIL_ASSISTANT');

  return (
    <div className="ai-email-context">
      <h6>{t('CONTEXT_TITLE')}</h6>
      <div className="ai-email-context-grid">
        <span>{t('DEAL_STAGE')}: <b>{deal.stage || '-'}</b></span>
        <span>{t('AMOUNT')}: <b>{formatNumber(deal.amount || 0)}</b></span>
        <span>{t('CLOSING_DATE')}: <b>{formatDate(deal.closing_date) || '-'}</b></span>
        <span>{t('SUCCESS_RATE')}: <b>{deal.success_rate || 0}%</b></span>
        <span>{t('COMPANY')}: <b>{deal.company_name || '-'}</b></span>
        <span>{t('CONTACT')}: <b>{deal.contact_name || '-'}</b></span>
      </div>
      <p>{t('RECENT_ACTIVITIES', { count: Math.min(activities.length, 3) })}</p>
    </div>
  );
}

ContextSummary.propTypes = {
  deal: PropTypes.shape({}).isRequired,
  activities: PropTypes.arrayOf(PropTypes.shape({})),
};

ContextSummary.defaultProps = {
  activities: [],
};

export default ContextSummary;
